import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-simple-data-card',
  templateUrl: './mini-simple-data-card.component.html',
  styleUrls: ['./mini-simple-data-card.component.scss']
})
export class MiniSimpleDataCardComponent implements OnInit {

  @Input() value;
  @Input() icon;
  @Input() subtitle;

  constructor() { }

  ngOnInit() {
  }

}
